import React, { memo } from 'react';

const MetamaskIcon = () => (
    <svg
        width="96"
        height="96"
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M88.7964 6.85718L53.4199 32.7885L60.016 17.5018L88.7964 6.85718Z"
            fill="#E17726"
            stroke="#E17726"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M7.20711 6.85718L42.2605 33.0019L35.9875 17.5285L7.20711 6.85718ZM76.0486 66.9634L66.6256 81.2096L86.7908 86.7053L92.5522 67.2835L76.0486 66.9634V66.9634ZM3.46484 67.2835L9.19939 86.7053L29.3107 81.2096L19.9416 66.9634L3.46484 67.2835V67.2835Z"
            fill="#E27625"
            stroke="#E27625"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M28.2308 42.8987L22.6309 51.2756L42.5537 52.1827L41.9076 30.9201L28.2308 42.9253V42.8987ZM67.7534 42.9253L53.8613 30.6533L53.4036 52.1827L73.3264 51.2756L67.7534 42.9253V42.9253ZM29.3077 81.2087L41.396 75.4462L31.0038 67.4427L29.3077 81.2087ZM54.6151 75.4195L66.6226 81.2087L65.0073 67.416L54.6151 75.4195Z"
            fill="#E27625"
            stroke="#E27625"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M66.6333 81.2098L54.6257 75.4473L55.595 83.184L55.4873 86.4654L66.6333 81.2098ZM29.3184 81.2098L40.5182 86.4654L40.4375 83.184L41.4067 75.4473L29.3184 81.2098Z"
            fill="#D5BFB2"
            stroke="#D5BFB2"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M40.7095 62.2944L30.748 59.4131L37.8018 56.2117L40.7364 62.2944H40.7095ZM55.2747 62.2944L58.2362 56.1851L65.3169 59.3865L55.2747 62.3211V62.2944Z"
            fill="#233447"
            stroke="#233447"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M29.3183 81.2104L31.0683 66.9642L19.9492 67.2843L29.3183 81.2104ZM64.9371 66.9642L66.6333 81.2104L76.0562 67.2843L64.9371 66.9642ZM73.364 51.2773L53.4411 52.1844L55.2719 62.3222L58.2334 56.1862L65.3141 59.3876L73.364 51.2773V51.2773ZM30.7452 59.4142L37.799 56.2128L40.7336 62.2955L42.5913 52.1577L22.6684 51.2773L30.7452 59.4142V59.4142Z"
            fill="#CC6228"
            stroke="#CC6228"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M22.6602 51.2773L31.0062 67.4177L30.737 59.4142L22.6602 51.2773ZM65.3058 59.4142L64.9827 67.4177L73.3288 51.2773L65.3058 59.4142ZM42.583 52.1844L40.6984 62.3222L43.0676 74.274L43.6061 58.5072L42.583 52.1844ZM53.4059 52.1844L52.4367 58.4805L52.9213 74.274L55.2636 62.2955L53.4059 52.1577V52.1844Z"
            fill="#E27525"
            stroke="#E27525"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M55.2723 62.2973L52.93 74.2758L54.6262 75.4497L64.9914 67.4462L65.3145 59.416L55.2723 62.2973ZM30.7457 59.416L31.0149 67.4195L41.4071 75.423L43.0763 74.2758L40.734 62.2973L30.7188 59.416H30.7457Z"
            fill="#F5841F"
            stroke="#F5841F"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M55.5142 86.4668L55.595 83.1854L54.6796 82.4384H41.3259L40.4375 83.1854L40.5182 86.4668L29.3184 81.2112L33.2491 84.4126L41.1913 89.8283H54.7873L62.7564 84.3859L66.6333 81.2112L55.4873 86.4668H55.5142Z"
            fill="#C0AC9D"
            stroke="#C0AC9D"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M54.6297 75.4177L52.9336 74.2705H43.0798L41.4106 75.4443L40.4414 83.1811L41.3299 82.4341H54.6835L55.5989 83.1811L54.6297 75.4443V75.4177Z"
            fill="#0A0A0A"
            stroke="#0A0A0A"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M90.295 34.4692L93.2565 20.1963L88.7873 6.85718L54.5954 31.9348L67.7606 42.8996L86.3373 48.2619L90.4296 43.5398L88.6527 42.2593L91.4796 39.6982L89.3258 38.0441L92.1526 35.9098L90.2681 34.4692H90.295ZM2.74219 20.1696L5.75754 34.4692L3.8191 35.8832L6.69983 38.0174L4.54601 39.6982L7.34598 42.2593L5.56908 43.5398L9.66133 48.2619L28.238 42.9262L41.4033 31.9081L7.21136 6.85718L2.74219 20.1696Z"
            fill="#763E1A"
            stroke="#763E1A"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
        <path
            d="M86.3331 48.265L67.7564 42.9293L73.3563 51.2796L65.0103 67.42L76.0486 67.2866H92.5522L86.3331 48.265ZM28.2338 42.9026L9.65708 48.265L3.46484 67.2866H19.9685L31.0068 67.42L22.6608 51.2796L28.2607 42.9026H28.2338ZM53.4066 52.1867L54.6181 31.9112L60.0026 17.5049H35.9875L41.3721 31.9112L42.5836 52.1867L43.0413 58.5361V74.2763H52.9219L52.9758 58.5361L53.4066 52.1867Z"
            fill="#F5841F"
            stroke="#F5841F"
            strokeWidth="0.181686"
            strokeLinecap="round"
            strokeLinejoin="round" />
    </svg>

);

export default memo(MetamaskIcon);
